import API from "../api/axios";

// Get All Targets
export const getSalesTargets = async () => {
   try {
      const response = await API.get("/sales-targets");
      return response.data;
   } catch (error) {
      throw error.response?.data || error;
   }
};

// Create Target
export const createSalesTarget = async (data) => {
   try {
      const response = await API.post("/sales-targets", data);
      return response.data;
   } catch (error) {
      throw error.response?.data || error;
   }
};

// Update Target
export const updateSalesTarget = async (id, data) => {
   try {
      const response = await API.put(`/sales-targets/${id}`, data);
      return response.data;
   } catch (error) {
      throw error.response?.data || error;
   }
};

// Delete Target
export const deleteSalesTarget = async (id) => {
   try {
      const response = await API.delete(`/sales-targets/${id}`);
      return response.data;
   } catch (error) {
      throw error.response?.data || error;
   }
};

// Get Target Progress
export const getSalesTargetProgress = async (salesPersonId) => {
   try {
      const response = await API.get(
         salesPersonId
            ? `/sales-targets/progress?sales_person_id=${salesPersonId}`
            : "/sales-targets/progress"
      );

      return response.data;
   } catch (error) {
      throw error.response?.data || error;
   }
};

export const getTeamTargetProgress = () => {
   return API.get("/sales-targets/team-progress");
};